import { Response } from '@/core'
import { AddInsuranceParams, PackageApiBuilder } from './package.api.types'

export const insuranceEndpoints = (builder: PackageApiBuilder) => ({
  addInsurance: builder.mutation<Response<void>, AddInsuranceParams>({
    query: ({ params, data }: AddInsuranceParams) => ({
      url: `/package/insurance/add`,
      method: 'post',
      params,
      data,
    }),
  }),
})
